
<template>
  <div class="root-actions">
    <a v-if="showDownloadButton" :href="downloadZipMusicUrl" class="btn btn-default"   target="_blank">
      <button style=" text-align: center;">Download file</button>
    </a>

    <Button @click.prevent="onBoxExportZipContent" style="width:153.23px!important;height:32px!important;margin:auto 0 auto auto!important; padding-left:9px;padding-right:9px; margin-right: 10px  ">
      <template v-if="!spinner">
        <span > {{ Translations.buttons.exportZipContent }} </span>
      </template>
      <template v-if="spinner">
        <span > <i class="fas fa-spinner fa-lg fa-spin"></i> </span>
      </template>
    </Button>
    <input
      type="text"
      v-if="isSearchVisible"
      ref="search"
      v-model="searchTrack"
      class="input"
      placeholder="Search"
    />
    <DropDownMenu v-if="currentBox !=null" :menus="menus" />
  </div>
</template>

<script>
import Vue from "vue";
import Translations from "@/store/translations";
import { mapState, mapActions } from "vuex";
import store from "@/store/index.js";
import DropDownMenu from "@/components/common/DropDownMenu.vue";
import EventBus from "@/eventbus";
import debounce from 'lodash/debounce'
import {HTTP} from "@/utils/http";

export default {
  name: "BoxActions",
  store,
  components: {
    DropDownMenu
  },
  computed: {
    Translations: () => Translations,
    ...mapState({
      currentBox: state => state.currentBox,
      isLoadingBox: state => state.loadingStates.isLoadingBox
    })
  },
  watch: {
     '$route': function () {
       this.showDownloadButton = false;
     },
    searchTrack: {
      handler: function(val) {
        this.commitSearch(val)
        
        // console.log('getters; ', this.$store.getters['Boxes/search'](val));
      }
    }
  },
  mounted() {
    console.log(this.$route.query.file , this.$route.query.token)
    if (this.$route.query.file && this.$route.query.token) {
      this.downloadZipMusic(this.$route.query.file , this.$route.query.token)
    } else{
      this.showDownloadButton = false;
    }
   this.getStatusExport();
  },
  data() {
    return {
      spinner: false,
      showDownloadButton: false,
      downloadZipMusicUrl: false,
      menus: [
        {
          external: true,
          iconClass: "fa-search",
          title: Translations.sections.boxes.details.actions.search,
          action: this.startSearchBoxTracks
        },
        // {
        //     external: true,
        //     iconClass: "fa-search-plus",
        //     title: Translations.sections.boxes.details.actions.searchAdvanced,
        //     action: this.startSearchBoxTracksAdvanced
        // },
        {
          external: true,
          iconClass: "fa-cog",
          title: Translations.sections.boxes.details.actions.edit,
          action: this.startEditBox
        },
        {
          external: false,
          iconClass: "fa-cog",
          title: Translations.sections.boxes.details.actions.edit,
          action: this.startEditBox
        },
        {
          external: false,
          iconClass: "fa-clone",
          title: Translations.sections.boxes.details.actions.duplicate,
          action: this.startDuplicateBox
        },
        { external: false, isDivider: true },
        {
          external: false,
          iconClass: "fa-trash-alt",
          title: Translations.sections.clocks.details.actions.delete,
          action: this.startDeleteBox
        }
      ],
      isSearchVisible: false,
      searchTrack: null
    };
  },
  methods: {
    makeToast(msg , type , title) {
      this.$store.dispatch('Toasts/addToast', {
        title: title,
        message: msg,
        type: type
      });
    },
    onBoxExportZipContent() {
      if (this.spinner === false) {
        this.spinner = true;
        HTTP.post("/api/boxes/music-zip-export" , {boxUid: location.pathname.split('/')[3], stationUid: location.pathname.split('/')[1]})
            .then(response => {
              console.log(response)
              if(response.status === 200){
                this.makeToast('Create task success, you will receive an email with further information', 'success' ,'Success')
              } else{
                this.makeToast('Failed to generate zip', 'danger' ,'Error')
              }
            }).catch(error => {
              // this.makeToast('Failed to load data', 'danger' ,'Error');
               this.spinner = false;
            })
      }
    },
    getStatusExport(){
      HTTP.get("/api/boxes/is-music-zip-export-in-progress")
          .then(response => {
            this.spinner = response.dataItem;
          }).then(this.updateSpinner).catch(this.updateSpinner);
    },
    updateSpinner() {
      console.log('updateSpinner', this.spinner)
      this.spinner = false;
    },
    downloadZipMusic(file, token){
          this.showDownloadButton = true;
          this.downloadZipMusicUrl = "https://preview.mcubedigital.com/audioZip/"+encodeURIComponent(file)+"?token="+token;
          console.log(this.downloadZipMusicUrl)

          // HTTP.get("https://preview.mcubedigital.com/audioZip/"+file+"?token="+token)
          //       .then(response => {
          //         console.log(response);
          //         const url = window.URL.createObjectURL(new Blob([response.data]));
          //         const link = document.createElement("a");
          //         link.href = url;
          //         window.open(url, '_blank');
          //         // link.setAttribute("target", "_blank");
          //         // link.setAttribute("download", "Box.zip");
          //         // document.body.appendChild(link);
          //         // link.click();
          //         // link.parentNode.removeChild(link);
          //       })

    },
    startDeleteBox(e) {
      EventBus.$emit("onBoxDelete", this.currentBox);
    },
    startDuplicateBox(e) {
      EventBus.$emit("onBoxDuplicate", this.currentBox.uid);
    },
    startEditBox(e) {
      EventBus.$emit("onBoxEdition", this.currentBox.uid);
    },
    startSearchBoxTracksAdvanced(e) {
      EventBus.$emit("advSearchTracks", this.currentBox.uid);
    },
    startSearchBoxTracks() {
      this.isSearchVisible = !this.isSearchVisible;
      this.$nextTick(() => {
        if (!!this.$refs.search) {
          this.$refs.search.focus();
        }
      });
    },
    commitSearch: debounce(function(val) {
      console.log(val)
     // this.$store.commit("Boxes/SEARCH_TERM", val);
      this.$store.dispatch('Boxes/getTrackList', {
                    stationUid: this.$route.params.stationUid,
                    boxUid: this.$route.params.boxUid,
                    page: 1,
                    pageSize: 100,
                    sortField:'artist',
                    sortAscending : true,
                    trackSearch: val,
                })
    }, 700)
  }
};
</script>

<style lang="scss" scoped>
.root-actions {
  display: flex;
  align-items: center;
  justify-content: center;

  .input {
    margin-right: 25px;
    height: 33px;
  }
}
</style>
